import SeoLinkPile from './SeoLinkpile';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  ...state.content.seoLinkpile,
  isMobile: state.system.isMobile,
  site: state.system.siteName
});

export default connect(mapStateToProps)(SeoLinkPile);
